var _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-website-designer:not(.animated) .animable {opacity: 0;}svg#freepik_stories-website-designer.animated #freepik--background-simple--inject-52 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-website-designer.animated #freepik--Page--inject-52 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown,3s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-website-designer.animated #freepik--Character--inject-52 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-website-designer.animated #freepik--Table--inject-52 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-website-designer.animated #freepik--Coffee--inject-52 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0.1s;opacity: 0}svg#freepik_stories-website-designer.animated #freepik--Floor--inject-52 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}            @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }")), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "247.324px 234.612px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M465,182.66c-16-52.31-57.15-94.18-105.85-116.25C312.72,45.35,254,35,210,67.35c-29,21.34-45.4,55.54-71.93,79.47-13.19,11.9-27.63,15.77-43.32,22.88-38.25,17.35-70.26,50.79-72.89,94.92-4.4,73.77,54.08,124.8,119.33,141.53,86.23,22.12,150.68,22.12,209.91-1.77,30.76-12.4,62.06-28.1,84.24-53.78,33.54-38.85,42.8-94,35.18-143.93A171.09,171.09,0,0,0,465,182.66Z",
    fill: "#12d3cf",
    style: {
      transformOrigin: "247.324px 234.612px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M465,182.66c-16-52.31-57.15-94.18-105.85-116.25C312.72,45.35,254,35,210,67.35c-29,21.34-45.4,55.54-71.93,79.47-13.19,11.9-27.63,15.77-43.32,22.88-38.25,17.35-70.26,50.79-72.89,94.92-4.4,73.77,54.08,124.8,119.33,141.53,86.23,22.12,150.68,22.12,209.91-1.77,30.76-12.4,62.06-28.1,84.24-53.78,33.54-38.85,42.8-94,35.18-143.93A171.09,171.09,0,0,0,465,182.66Z",
    fill: "#fff",
    opacity: 0.8,
    style: {
      transformOrigin: "247.324px 234.612px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "259.13px 143px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 72,
    y: 39,
    width: 343,
    height: 208,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "243.5px 143px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 83.67,
    y: 66.33,
    width: 186,
    height: 16.25,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "176.67px 74.455px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 83.67,
    y: 91.79,
    width: 186,
    height: 93.88,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "176.67px 138.73px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 280.21,
    y: 159.66,
    width: 125.97,
    height: 74.78,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "343.195px 197.05px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 280.21,
    x2: 406.18,
    y1: 234.44,
    y2: 159.66,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "343.195px 197.05px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 406.18,
    x2: 280.21,
    y1: 234.44,
    y2: 159.66,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "343.195px 197.05px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 237.07,
    x2: 267.55,
    y1: 199.93,
    y2: 199.93,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "252.31px 199.93px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 183,
    x2: 230.74,
    y1: 199.93,
    y2: 199.93,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "206.87px 199.93px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 109.37,
    x2: 173.79,
    y1: 199.93,
    y2: 199.93,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "141.58px 199.93px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 84.64,
    x2: 101.89,
    y1: 199.93,
    y2: 199.93,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "93.265px 199.93px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 129.5,
    x2: 267.55,
    y1: 208.55,
    y2: 208.55,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "198.525px 208.55px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 84.64,
    x2: 122.6,
    y1: 208.55,
    y2: 208.55,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "103.62px 208.55px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 202.55,
    x2: 267.55,
    y1: 217.18,
    y2: 217.18,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "235.05px 217.18px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 138.13,
    x2: 193.35,
    y1: 217.18,
    y2: 217.18,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "165.74px 217.18px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 84.64,
    x2: 131.8,
    y1: 217.18,
    y2: 217.18,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "108.22px 217.18px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 192.2,
    x2: 267.55,
    y1: 225.81,
    y2: 225.81,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "229.875px 225.81px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 130.65,
    x2: 184.72,
    y1: 225.81,
    y2: 225.81,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "157.685px 225.81px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 84.64,
    x2: 124.33,
    y1: 225.81,
    y2: 225.81,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "104.485px 225.81px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 234.19,
    x2: 267.55,
    y1: 234.44,
    y2: 234.44,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "250.87px 234.44px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 155.39,
    x2: 227.86,
    y1: 234.44,
    y2: 234.44,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "191.625px 234.44px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 122.6,
    x2: 149.06,
    y1: 234.44,
    y2: 234.44,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "135.83px 234.44px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 96.72,
    x2: 112.25,
    y1: 234.44,
    y2: 234.44,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "104.485px 234.44px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 84.64,
    x2: 96.72,
    y1: 234.44,
    y2: 234.44,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "90.68px 234.44px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 72,
    y: 39,
    width: 343,
    height: 15,
    fill: "#12d3cf",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "243.5px 46.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 121.27,
    y: 43.5,
    width: 286,
    height: 6.05,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "264.27px 46.525px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 77.28,
    y: 43.5,
    width: 38.03,
    height: 6.05,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "96.295px 46.525px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 304.7,
    y: 74.96,
    width: 130,
    height: 74,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "369.7px 111.96px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 304.7,
    y: 134.96,
    width: 130,
    height: 14,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "369.7px 141.96px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "386.81 106.26 352.6 86.51 352.6 126.01",
    fill: "#12d3cf",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "369.705px 106.26px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 301.49,
    y: 71.08,
    width: 7.48,
    height: 7.48,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "305.23px 74.82px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 430.62,
    y: 71.08,
    width: 7.48,
    height: 7.48,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "434.36px 74.82px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 301.49,
    y: 143.84,
    width: 7.48,
    height: 7.48,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "305.23px 147.58px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 430.62,
    y: 143.84,
    width: 7.48,
    height: 7.48,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "434.36px 147.58px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m149.34 135.84v13h-3.23v-28.92h3.23v13h7.11v-13h3.22v28.94h-3.22v-13z",
    fill: "#263238",
    style: {
      transformOrigin: "152.89px 134.39px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m167.15 148.86v-26h-5.33v-2.94h13.85v2.94h-5.33v26z",
    fill: "#263238",
    style: {
      transformOrigin: "168.745px 134.39px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m188.52 148.82h-3.1l-4.79-23v23.07h-2.81v-28.97h4.5l4.76 23.08 4.59-23.11h4.5v28.94h-3.06v-23.24z",
    fill: "#263238",
    style: {
      transformOrigin: "186.995px 134.39px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m199.48 148.86v-28.94h3.22v26h8.3v2.94z",
    fill: "#263238",
    style: {
      transformOrigin: "205.24px 134.39px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M417.2,145.5l6.91,31a1.09,1.09,0,0,0,2,.19l4.48-9.43a1.07,1.07,0,0,1,1-.62l10.42.57a1.09,1.09,0,0,0,.81-1.87L419,144.43A1.09,1.09,0,0,0,417.2,145.5Z",
    fill: "#263238",
    style: {
      transformOrigin: "430.157px 160.7px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 436.33,
    y: 173,
    width: 9.33,
    height: 9.33,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".75px",
    style: {
      transformOrigin: "440.995px 177.665px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 435.58,
    y: 172.26,
    width: 1.4,
    height: 1.4,
    fill: "#263238",
    style: {
      transformOrigin: "436.28px 172.96px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 440.32,
    y: 172.26,
    width: 1.4,
    height: 1.4,
    fill: "#263238",
    style: {
      transformOrigin: "441.02px 172.96px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 444.86,
    y: 172.26,
    width: 1.4,
    height: 1.4,
    fill: "#263238",
    style: {
      transformOrigin: "445.56px 172.96px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 435.58,
    y: 176.98,
    width: 1.4,
    height: 1.4,
    fill: "#263238",
    style: {
      transformOrigin: "436.28px 177.68px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 440.32,
    y: 176.98,
    width: 1.4,
    height: 1.4,
    fill: "#263238",
    style: {
      transformOrigin: "441.02px 177.68px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 444.86,
    y: 176.98,
    width: 1.4,
    height: 1.4,
    fill: "#263238",
    style: {
      transformOrigin: "445.56px 177.68px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 435.58,
    y: 181.52,
    width: 1.4,
    height: 1.4,
    fill: "#263238",
    style: {
      transformOrigin: "436.28px 182.22px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 440.32,
    y: 181.52,
    width: 1.4,
    height: 1.4,
    fill: "#263238",
    style: {
      transformOrigin: "441.02px 182.22px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 444.86,
    y: 181.52,
    width: 1.4,
    height: 1.4,
    fill: "#263238",
    style: {
      transformOrigin: "445.56px 182.22px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "271.26px 314.36px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "191.47 316.84 188.51 317.42 179.94 275.05 182.9 274.47",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "185.705px 295.945px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 188.33,
    y: 316,
    width: 56.3,
    height: 2.01,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "216.48px 317.005px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 260.21,
    y: 421.55,
    width: 86.99,
    height: 4.25,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "303.705px 423.675px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m360.33 290.59s-8.24 65.32-10.52 85.56 6.68 83.78 6.68 83.78h-5.23l-10.27-72h-76.74l-4.91 70.71h-3.92l6.58-82.16v-8.93a3.48 3.48 0 0 1 3.48-3.48h73.52l11.51-80.66s1.3-7.51 7.83-5.22 1.99 12.4 1.99 12.4z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "308.643px 368.843px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M358.37,278.19a5.25,5.25,0,0,0-.52-.17c.5,1,.8,2.74.2,6-1.31,7.19-15.1,92.75-15.1,92.75h-81l-6.49,82.82h3.92l8.54-71.72H341l10.27,72h5.23s-9-63.53-6.68-83.78,12.06-84.07,12.06-84.07S364.91,280.47,358.37,278.19Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "309.02px 368.945px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M280.1,296.29l-40.87,2.32L221,309.15l-3.6,6.17,2.82.51,6.43-2.83s7.2-1.28,9.26-2.05S243.6,304,243.6,304l38,6.17Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "249.5px 306.06px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m221.15 422.6s-7.2 12.6-8.23 12.6-9.37 1.85-16-1.49-11.57-5.91-13.63-2.83a23.27 23.27 0 0 0-2.57 4.63s6.17 8.74 11.83 11.82 8.08 1.49 14 4.83 6.43 5.91 11.31 4.89 7.72-16.71 9-18.51 6.14-11.83 6.14-11.83z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "206.86px 439.938px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m214.16 433.9c-0.59 0.8-1 1.3-1.24 1.3-1 0-9.37 1.85-16-1.49s-11.57-5.91-13.63-2.83a23.27 23.27 0 0 0-2.57 4.63s6.17 8.74 11.83 11.82 8.08 1.49 14 4.83 6.43 5.91 11.31 4.89c4.33-0.92 7-13.31 8.5-17.39-4.44-1.14-9.2-3.85-12.2-5.76z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "203.54px 443.387px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M217.8,457.05a3.09,3.09,0,0,0,.43-.14.84.84,0,0,0,.14-.06l.28-.14.16-.1.25-.17.16-.13.24-.21.15-.15a3.07,3.07,0,0,0,.25-.26l.14-.16c.08-.1.17-.2.25-.31l.12-.15.29-.42.07-.1c.2-.3.39-.63.58-1-5,0-8.4-3.15-13.79-5-6.68-2.31-7.06-.45-11.94-3.8s-5.4-5.39-5.4-5.39l4.33-6.84c-5.47-2.7-9.46-4.36-11.27-1.65a23.27,23.27,0,0,0-2.57,4.63s6.17,8.74,11.83,11.82,8.08,1.49,14,4.83S212.92,458.07,217.8,457.05Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "200.99px 443.381px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m228.86 358.33-22.86 57.07 27.25 15.43s29-65.81 29.3-67.1 5.4-2.57 5.4-2.57l20.8 2.84s-31.36-13.88-40.61-15.94-15.43-0.52-19.28 10.27z",
    fill: "#12d3cf",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "247.375px 389.053px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M252.59,402.72l12.86,12.08s-4.37,10.8-9.51,17.74-5.66,11-3.35,12.59,6.94,1.29,10-.77,20.56-19.28,22.62-22.36a5.17,5.17,0,0,0-1-6.68c-.77-.52-17.73-20.83-17.73-20.83Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "268.644px 420.317px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M285.24,422a5.17,5.17,0,0,0-1-6.68c-.36-.25-4.35-4.92-8.46-9.78-3.76,4.55-10.55,7.09-12.05,7.62l1.75,1.64s-4.37,10.8-9.51,17.74-5.66,11-3.35,12.59,6.94,1.29,10-.77S283.18,425.08,285.24,422Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "268.674px 425.842px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m284.54 415.6a9 9 0 0 1-1.87 4.86c-3.08 3.85-20.31 19.79-20.31 19.79l-8-5.52c-3.68 5.62-3.87 9-1.82 10.4 2.32 1.55 6.94 1.29 10-0.77s20.56-19.28 22.62-22.36a5.18 5.18 0 0 0-0.62-6.4z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "268.611px 430.863px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m277.27 414.29a2.7 2.7 0 1 1-2.7-2.57 2.64 2.64 0 0 1 2.7 2.57z",
    fill: "#fff",
    style: {
      transformOrigin: "274.573px 414.42px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M285.5,321.49l-1.29,4.37s-38.81.51-55.78,5.14-21.59,7.2-20.31,16.71S235.63,412,235.63,412a105.89,105.89,0,0,0,15.42-5.65A97.43,97.43,0,0,0,267.76,396l-19.54-37.28s22.37,4.63,47.3,6.94,35.48-.26,39.59-7.71-2.83-37.27-2.83-37.27l-46.52-1.55Z",
    fill: "#12d3cf",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "272.165px 365.565px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m231 346.45a15.23 15.23 0 0 1-2.29-2.86",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "229.855px 345.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m248.22 358.76a114.21 114.21 0 0 1-14.82-10.07",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "240.81px 353.725px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m251.1 380.23 2.06 1",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "252.13px 380.73px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m215.11 349.92a108.61 108.61 0 0 0 32.42 28.35",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "231.32px 364.095px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m322.81 338.53a29 29 0 0 1 2.79 2.47",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "324.205px 339.765px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m286.78 326.37s18.84 1.46 32.14 9.48",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "302.85px 331.11px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M312.49,330.74s12.34.26,17.22,5.4",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "321.1px 333.44px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M289.1,244.37s-8.74,26-10,33.93-.51,42.67-.51,42.67,20.56,6.17,32.13,4.89,26-3.6,26-3.6-2.57-46-4.88-61.95-7.71-25.2-12.85-29.05a80.38,80.38,0,0,0-10.8-6.69Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "307.544px 275.302px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M243.85,204.27a27.83,27.83,0,0,0,3.35,9.25c2.57,4.11,6.17,5.91,5.14,10s-1,6.94,2,7.19l3.09.26s6.17,10.54,10.8,10.54S286,229.72,286,229.72s-6.94-32.65-6.94-33.68-36.76,3.86-36.76,3.86Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "264.15px 218.704px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m259.15 217.48c0.49 1 0.32 2.13-0.39 2.47s-1.67-0.22-2.16-1.25-0.32-2.13 0.39-2.46 1.67 0.22 2.16 1.24z",
    fill: "#263238",
    style: {
      transformOrigin: "257.875px 218.097px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M252.85,214.55s-.26-3.6,5.14-2.83",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "255.419px 213.081px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M260.36,231.82c.16.57,6.28.23,5.34-5.19",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "263.079px 229.325px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M296,192.18c-.85-10.41-13.81-6.42-19.88-3.27l-.17-.32-24.42,6.94a4.84,4.84,0,0,0,2.31,5.14,35.62,35.62,0,0,0,17.49,6.85c1.82,10.88,4.36,27.14,4.36,33.25,0,9.51-3.6,13.11-3.6,13.11s16.45-5.14,26-14.14a86.14,86.14,0,0,0,14.4-17.48S297.07,204.78,296,192.18Z",
    fill: "#12d3cf",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "281.962px 219.668px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 271.37,
    x2: 270.64,
    y1: 207.52,
    y2: 204.12,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "271.005px 205.82px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M283.57,231.18c.21,1.17.38,2.26.5,3.21",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "283.82px 232.785px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m277.21 204.12s3.63 13.41 5.68 23.48",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "280.05px 215.86px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 289.35,
    x2: 294.34,
    y1: 207.49,
    y2: 220.68,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "291.845px 214.085px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 287.21,
    x2: 288.5,
    y1: 201.83,
    y2: 205.24,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "287.855px 203.535px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 293.49,
    x2: 295.77,
    y1: 202.12,
    y2: 207.83,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "294.63px 204.975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m241.33 203.87s-17.2 9.13-11.47 9.13 34.41-11.85 35.55-11.85-19.11 1.95-24.08 2.72z",
    fill: "#757575",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "247.074px 207.075px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m241.33 203.87s-10.29 3.26-5.7-7.83 35.84-27.25 48.84-27.25 22.61 19.4 20.7 25.52-6.12 6.88-8 6.88-55.84 2.68-55.84 2.68z",
    fill: "#757575",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "269.932px 186.553px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M246.3,200.43s18.73.38,34.79-1.91,22.55-4.59,22.55-4.59",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "274.97px 197.192px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 301.35,
    x2: 276.12,
    y1: 198.9,
    y2: 199.28,
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "288.735px 199.09px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M285.5,299.89,282.16,303s-41.65-5.4-44.48-4.63-12.85,3.6-12.85,3.6l-8,.51-6.42,10.8h2.05l4.63-6.43H220l-4.89,5.66L213,315.57l7.19.26,1.05-.89,4.1-3.48-1.29,3.86h1.54l3.6-6.17,4.89-2.57,5.14-3.6s52.44,18.25,53.72,19,4.12,2.83,6.43.77,8.48-19.28,8.48-19.28Z",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "259.13px 310.965px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M216.22,315.22a35.91,35.91,0,0,0,7-7.31s.35-2.71,2.71-3.14",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "221.075px 309.995px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "animable",
    points: "225.35 311.46 226.51 306.99 227.79 305.96",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "226.57px 308.71px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M220,306.83a14.24,14.24,0,0,1,2.44-2.94c.87-.52,1.4-.78,1.4-.78",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "221.92px 304.97px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M263.5,311.46C277.42,316.34,292.28,321.6,293,322c1.29.77,4.12,2.83,6.43.77s8.48-19.28,8.48-19.28l-22.36-3.6L282.16,303s-7.66-1-16.62-2.07Z",
    fill: "#757575",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "285.705px 311.775px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m293 260.82-11.1 37.27s1 5.15 11.31 8a64 64 0 0 0 17.48 2.57l8.23-46.27",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "300.41px 284.74px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 292.26,
    x2: 282.23,
    y1: 264.18,
    y2: 295.27,
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "287.245px 279.725px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 316.75,
    x2: 311.82,
    y1: 274.14,
    y2: 305.8,
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "314.285px 289.97px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 317.83,
    x2: 317.29,
    y1: 267.18,
    y2: 270.66,
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "317.56px 268.92px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "194.87px 388.955px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 191.5,
    y: 320.5,
    width: 9,
    height: 133.8,
    fill: "#263238",
    style: {
      transformOrigin: "196px 387.4px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 127.89,
    y: 318.14,
    width: 133.96,
    height: 5.53,
    fill: "#757575",
    style: {
      transformOrigin: "194.87px 320.905px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m244.23 459.77h-96.44a5.54 5.54 0 0 1 5.53-5.53h85.38a5.54 5.54 0 0 1 5.53 5.53z",
    fill: "#757575",
    style: {
      transformOrigin: "196.01px 457.005px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "157.48px 301.035px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "166.61 319.12 149.01 319.12 146.37 286.2 169.25 286.2",
    fill: "#12d3cf",
    style: {
      transformOrigin: "157.81px 302.66px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 144.77,
    y: 282.95,
    width: 25.42,
    height: 7.5,
    fill: "#fff",
    style: {
      transformOrigin: "157.48px 286.7px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "167.34 309.99 168.31 297.94 147.31 297.94 148.28 309.99",
    fill: "#fff",
    style: {
      transformOrigin: "157.81px 303.965px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      transformOrigin: "254.9px 459.93px"
    }
  }, /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 452.33,
    x2: 464.33,
    y1: 459.93,
    y2: 459.93,
    style: {
      transformOrigin: "458.33px 459.93px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 432.33,
    x2: 445,
    y1: 459.93,
    y2: 459.93,
    style: {
      transformOrigin: "438.665px 459.93px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 127.67,
    x2: 425,
    y1: 459.93,
    y2: 459.93,
    style: {
      transformOrigin: "276.335px 459.93px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    className: "animable",
    x1: 45.47,
    x2: 118.33,
    y1: 459.93,
    y2: 459.93,
    style: {
      transformOrigin: "81.9px 459.93px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainImage);
export default __webpack_public_path__ + "static/media/mainImage.1d5dbfd9cba554131b4ae5d354cb1956.svg";
export { ForwardRef as ReactComponent };